module.exports = __webpack_public_path__ + "static/media/star.1c7624aa.png";